import React, { useState } from "react";
import { Alert, Button, Spin } from "antd";
import styles from "./index.module.scss";
import InfoCard from "./components/InfoCard";
import { useHistory } from "react-router-dom";
import useRequest from "../../../../../utils/useRequest";
import { getMonitorListStatistic } from "../../../../../service/exam";
import { useInterval } from "react-use";
import useModalHandler from "../../../../../utils/v2/useModalHandler";
import InfoModal from "./components/InfoModal";

export default function TabInvigilation() {
    const history = useHistory();

    const [refreshList, setRefreshList] = useState("0");
    const [data, { loading }, reload] = useRequest(
        () => getMonitorListStatistic(refreshList),
        {},
        [refreshList]
    );

    function rePost() {
        setRefreshList("0");
        if (!loading) {
            if (refreshList === "0") {
                reload();
            }
        }
    }

    async function reloadAction() {
        setRefreshList("1");
        if (refreshList === "1") {
            reload();
        }
    }

    useInterval(rePost, 10 * 1000);

    const infoModal = useModalHandler(InfoModal, { remove: true });

    return (
        <div className={styles.root}>
            <Alert
                message="温馨提示：监考列表展示的是当前时点，您名下有监考任务的考核的考生参考详细情况，如果当前时点你名下无监考任务，那么此界面每个维度的检测始终是0."
                type="info"
                showIcon
            />

            <div className={styles.btnRow}>
                <Button
                    type="primary"
                    ghost
                    onClick={reloadAction}
                    style={{ marginRight: 15 }}>
                    刷新
                </Button>
                <Button type="primary" ghost onClick={infoModal.open}>
                    查看监考任务详情
                </Button>
            </div>

            <Spin spinning={loading}>
                <div className={styles.body}>
                    <InfoCard
                        variant={
                            (data?.notJoinNum || 0) > 0 ? "warn" : "normal"
                        }
                        title="未参考人员监测"
                        count={data?.notJoinNum || 0}
                        desc="考生参加考试情况后台监测"
                        onClick={() =>
                            history.push(
                                "/exam/invigilation/log/not_taking_exam"
                            )
                        }
                    />

                    <InfoCard
                        variant="normal"
                        title="考生抓拍记录"
                        desc="只记录已开启摄像头抓拍的考核的考生抓拍情况"
                        onClick={() =>
                            history.push(
                                "/exam/invigilation/log/cam_capture_record"
                            )
                        }
                    />

                    {/*<InfoCard*/}
                    {/*    variant="normal"*/}
                    {/*    title="抓屏记录"*/}
                    {/*    desc="只记录已开启屏幕抓拍的考核的考试界面的抓拍情况"*/}
                    {/*    onClick={() =>*/}
                    {/*        history.push(*/}
                    {/*            "/exam/invigilation/log/screen_capture_record"*/}
                    {/*        )*/}
                    {/*    }*/}
                    {/*/>*/}

                    <InfoCard
                        variant={
                            (data?.leaveScreenNum || 0) > 0 ? "warn" : "normal"
                        }
                        title="考生切屏情况监测"
                        desc="系统实时统计监考的考核中有切屏操作的考生切屏详情"
                        count={data?.leaveScreenNum || 0}
                        onClick={() =>
                            history.push("/exam/invigilation/log/shift_browser")
                        }
                    />

                    <InfoCard
                        variant={
                            (data?.multiScreenNum || 0) > 0 ? "warn" : "normal"
                        }
                        title="多屏监测"
                        desc="系统自动监测考生是否开启双屏"
                        count={data?.multiScreenNum || 0}
                        onClick={() =>
                            history.push(
                                "/exam/invigilation/log/multiple_screen"
                            )
                        }
                    />

                    <InfoCard
                        variant="normal"
                        title="已交卷考生情况"
                        desc="考生要交卷时，可以结合其他实时直播软件的双机位确认交卷情况及提交附件数"
                        onClick={() =>
                            history.push("/exam/invigilation/log/submitted")
                        }
                    />

                    <InfoCard
                        variant="normal"
                        title="参考全过程日志"
                        desc="查看每个考生从打开试卷一直到交卷的所有日志情况"
                        onClick={() =>
                            history.push("/exam/invigilation/log/all")
                        }
                    />

                    <InfoCard
                        variant={
                            (data?.downloadNum || 0) > 0 ? "warn" : "normal"
                        }
                        title="下载试卷记录"
                        desc="考生若下载试卷，下载记录会实时同步监考老师端，老师可以通过腾讯会议副机位与考生确认下载附件的用意。"
                        count={data?.downloadNum || 0}
                        onClick={() =>
                            history.push("/exam/invigilation/log/download")
                        }
                    />

                    <InfoCard
                        variant="normal"
                        title="监考列表"
                        desc="上学期的监考列表，只不过入口不是在考核的“监考”了"
                        onClick={() => history.push("/exam/invigilation/list")}
                    />

                    <InfoCard
                        variant={
                            (data?.ipAbnormalNum || 0) > 0 ? "warn" : "normal"
                        }
                        title="IP变更监测"
                        count={data?.ipAbnormalNum || 0}
                        desc="先在【查看监考任务详情】中进行IP池设定，考试过程中出现范围外IP将给出预警"
                        onClick={() => history.push("/exam/invigilation/ip")}
                    />

                    <InfoCard
                        variant={
                            (data?.loginAbnormalNum || 0) > 0
                                ? "warn"
                                : "normal"
                        }
                        title="多次登录监测"
                        count={data?.loginAbnormalNum || 0}
                        desc="考生在考试时间内有多次登录的行为"
                        onClick={() => history.push("/exam/invigilation/login")}
                    />
                </div>
            </Spin>

            {infoModal.render(<InfoModal />)}
        </div>
    );
}
